/*
 * AN ask_user CALL AS A TOOL ROW.
 *
 * A question put to a person is part of the conversation — it is where a decision was made and who
 * made it — so it stays in the transcript. It is drawn as the SAME collapsed, expandable row every
 * other call uses, not as a framed card of its own: one visual grammar for everything the assistant
 * did, and the row's one line already says the question. The clean surface is the prompt above the
 * composer while the question is live; the transcript keeps the record.
 *
 * Its own module so the transcript renderer can use it without importing the tool (whose module
 * registers a client tool as a side effect and reaches the dispatch layer).
 */
import { html, nothing } from 'lit';
import { t } from '../i18n';
import { renderMarkdown } from './markdown';
import { copyCode } from './turn-view';
/** The question and options out of arguments that may be half-written mid-stream. */
function parseAsk(tool) {
    try {
        const args = JSON.parse(tool.argumentsJson || '{}');
        return { question: String(args.question ?? ''), options: Array.isArray(args.options) ? args.options.map((o) => String(o)) : [] };
    }
    catch {
        return { question: '', options: [] };
    }
}
export function askRow(tool) {
    const { question, options } = parseAsk(tool);
    // An unresolved call is a question STILL WAITING; anything else that is not an answer — the run
    // stopped, the tab reloaded, the person moved on — is a question that got none.
    const waiting = tool.state === 'running';
    const answered = tool.state === 'ok';
    const answer = answered ? (tool.message ?? '') : '';
    const q = question || t('ai.askedYou');
    const said = answered && answer ? `${q} — ${answer}` : q;
    const body = html `
    <div class="ask-card">
      <div class="ask-card-q">${renderMarkdown(q, copyCode)}</div>
      ${options.length ? html `<div class="ask-card-opts">${options.map((o) => html `<span>${o}</span>`)}</div>` : nothing}
      <div class="ask-card-a ${waiting ? 'waiting' : ''}">
        <span class="ask-card-label">${waiting ? t('ai.awaitingYou') : answered ? t('ai.youAnswered') : t('ai.noAnswer')}</span>
        ${answered ? html `<span>${answer || t('ai.noAnswer')}</span>` : nothing}
      </div>
    </div>
  `;
    return { said, body };
}
//# sourceMappingURL=ask-row.js.map